// composables/useSession.ts
import Cookies from 'js-cookie';

export type CookieOptions = {
    expires?: number | Date;
    path?: string;
    domain?: string;
    secure?: boolean;
    sameSite?: 'strict' | 'lax' | 'none';
};

export function useSession() {
    const set = (name: string, value: string, options?: CookieOptions) => {
        Cookies.set(name, value, options);
    };

    const get = (name: string, _default?: any) => {
        return Cookies.get(name) ?? _default;
    };

    const remove = (name: string, options?: Pick<CookieOptions, 'path' | 'domain'>) => {
        Cookies.remove(name, options);
    };

    return { set, get, remove };
}
